import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { KitComponent } from './createKitComponent';
import type { ReadRequestOptions } from '../requestOptions';

export interface KitConfiguration {
  id: number;
  product_id: number;
  created_at?: string;
  created_by?: string;
  updated_at?: string;
  updated_by?: string;
  components?: KitComponent[];
}

export const getKitConfigurations = async (
  scope: RequestScope,
  productId: string,
  options: ReadRequestOptions
): Promise<EndpointResponse<KitConfiguration[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<KitConfiguration[]>>('/kit_configuration', {
      ...options,
      params: {
        limit: 100,
        query: { product_id: parseInt(productId) },
      },
    });
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
